import { useParams } from 'react-router-dom';
import AttachmentsList from '../../../components/attachments/AttachmentsList';
import { ATTACHMENT_TYPES } from '../../../constants/settings.constants';
import { useAttachmentCRUD } from '../../../hooks/useAttachmentCRUD.hook';
import AttachmentDetailsModal from '../../../modals/AttachmentDetailsModal';
import AttachmentUploadModal from '../../../modals/AttachmentUploadModal';
import DeleteWarningModal from '../../../modals/DeleteWarningModal';

const DossierDetailAttachments = ({ permissions, attachments, isLoadingAttachments }) => {
  const params = useParams();
  const attachmentCRUD = useAttachmentCRUD(params.id);

  if (!permissions.read) {
    return null;
  }

  return (
    <div>
      <AttachmentsList
        attachments={attachments}
        loading={isLoadingAttachments}
        onUpload={permissions.write ? () => attachmentCRUD.onAttachmentAddOpen('', ATTACHMENT_TYPES.OTHER) : undefined}
        onOpen={attachmentCRUD.onAttachmentOpen}
      />
      <AttachmentUploadModal {...attachmentCRUD.uploadModal} onConfirm={attachmentCRUD.onAttachmentAdd} />
      <AttachmentDetailsModal
        {...attachmentCRUD.detailsModal}
        {...permissions}
        form={attachmentCRUD.attachmentDetailForm}
        dossierId={params.id}
        onUpdate={attachmentCRUD.onAttachmentUpdate}
        onUpdateSuccess={attachmentCRUD.onAttachmentsRefetch}
        onDelete={
          attachmentCRUD.openedAttachmentType === ATTACHMENT_TYPES.OTHER ? attachmentCRUD.deleteModal.onOpen : undefined
        }
      />
      {attachmentCRUD.deleteModal.isOpen && (
        <DeleteWarningModal
          {...attachmentCRUD.deleteModal}
          warningText="Weet je zeker dat je deze bijlage wilt verwijderen?"
          onConfirm={attachmentCRUD.onAttachmentDelete}
        />
      )}
    </div>
  );
};

export default DossierDetailAttachments;
